import { instance as axios } from '../untils/http'
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { errorHandler } from '../untils/errorHandler';
import { ErrorInformation } from 'src/models/errorInformation';
import { Company , JobgradeMaster , Termination , Department , CostCenter } from 'src/models/profileInformation';
import { CompanyInsert , JobgradeInsert , TerminationInsert ,
         DepartmentInsert , CostcenterInsert } from 'src/models/manageLookup';

//================|| PERFORMANCE PERSONAL LEDGER SLICE ||=================//
type MasterState = {
    loading: boolean;
    error: ErrorInformation;
    company: Company[];
    jobGrade: JobgradeMaster[];
    termination: Termination[];
    department: Department[];
    costCenter: CostCenter[];
    NewUserResponseMessage: string;
}

type MasterInfo = {
    company: Company[];
    jobGrade: JobgradeMaster[];
    termination: Termination[];
    department: Department[];
    costCenter: CostCenter[];
}

const initialState: MasterState = {
    loading: true,
    error: null,
    company: [],
    jobGrade: [],
    termination: [],
    department: [],
    costCenter: [],
    NewUserResponseMessage: '',
};

export const getMaster = createAsyncThunk<MasterInfo, {}, { rejectValue: ErrorInformation }>(
    "master/getMaster",
    async ({ }, { rejectWithValue }) => {
        try {
            const getCompanyResponse = await axios.get<Company[]>('Misc/getCompany');
            const jobGradeResponse = await axios.get<JobgradeMaster[]>('/Profile/getJobGrade');
            const terminationResponse = await axios.get<Termination[]>('/Misc/getTermination');
            const departmentResponse = await axios.get<Department[]>('/Misc/getDepartment');
            const costCenterResponse = await axios.get<CostCenter[]>('/Misc/getCostCenter');
            return {
                company: getCompanyResponse.data,
                jobGrade: jobGradeResponse.data,
                termination: terminationResponse.data,
                department: departmentResponse.data,
                costCenter: costCenterResponse.data,
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const insertCompany = createAsyncThunk<string, { companyInfo: CompanyInsert , status }, { rejectValue: ErrorInformation }>(
    "master/insertCompany",
    async ({companyInfo , status}, { rejectWithValue }) => {
        try {
            if(status == 'ADD'){
                const response = await axios.post('/Profile/insertCompany', companyInfo)
                return response.data[0];
            } else if(status == 'EDIT') {
                const response = await axios.put('/Profile/updateCompany', companyInfo)
                return response.data[0];
            }else if(status == 'DEL') {
                const params = {companyID: companyInfo.companyID};
                const response = await axios.delete('/Profile/deleteCompany', {
                    data: params
                  })
                return response.data[0];
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const insertjobgrade = createAsyncThunk<string, { jobInfo: JobgradeInsert , status }, { rejectValue: ErrorInformation }>(
    "master/insertjobgrade",
    async ({jobInfo , status}, { rejectWithValue }) => {
        try {
            if(status == 'ADD'){
                const response = await axios.post('/Profile/insertJobGrade', jobInfo)
                return response.data[0];
            } else if(status == 'EDIT') {
                const response = await axios.put('/Profile/updateJobGrade', jobInfo)
                return response.data[0];
            }else if(status == 'DEL') {
                const params = {jobGradeID: jobInfo.jobGradeID};
                const response = await axios.delete('/Profile/deleteJobGrade', {
                    data: params
                  })
                return response.data[0];
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const insertTermination = createAsyncThunk<string, { terminationInfo: TerminationInsert , status }, { rejectValue: ErrorInformation }>(
    "master/insertTermination",
    async ({terminationInfo , status}, { rejectWithValue }) => {
        try {
            if(status == 'ADD'){
                const response = await axios.post('/Profile/insertTermination', terminationInfo)
                return response.data[0];
            } else if(status == 'EDIT') {
                const response = await axios.put('/Profile/updateTermination', terminationInfo)
                return response.data[0];
            }else if(status == 'DEL') {
                const params = {terminationID: terminationInfo.terminationID};
                const response = await axios.delete('/Profile/deleteTermination', {
                    data: params
                  })
                return response.data[0];
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const insertDepartment = createAsyncThunk<string, { departmentInfo: DepartmentInsert , status }, { rejectValue: ErrorInformation }>(
    "master/insertDepartment",
    async ({departmentInfo , status}, { rejectWithValue }) => {
        try {
            if(status == 'ADD'){
                const response = await axios.post('/Profile/insertDepartment', departmentInfo)
                return response.data[0];
            } else if(status == 'EDIT') {
                const response = await axios.put('/Profile/updateDepartment', departmentInfo)
                return response.data[0];
            }else if(status == 'DEL') {
                const params = {departmentID: departmentInfo.departmentID};
                const response = await axios.delete('/Profile/deleteDepartment', {
                    data: params
                  })
                return response.data[0];
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const inserCostCenter = createAsyncThunk<string, { costcenterInfo: CostcenterInsert , status }, { rejectValue: ErrorInformation }>(
    "master/inserCostCenter",
    async ({costcenterInfo , status}, { rejectWithValue }) => {
        try {
            if(status == 'ADD'){
                const response = await axios.post('/Profile/insertCostCenter', costcenterInfo)
                return response.data[0];
            } else if(status == 'EDIT') {
                const response = await axios.put('/Profile/updateCostCenter', costcenterInfo)
                return response.data[0];
            }else if(status == 'DEL') {
                const params = {costCenterID: costcenterInfo.costCenterID};
                const response = await axios.delete('/Profile/deleteCostCenter', {
                    data: params
                  })
                return response.data[0];
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

const masterSlice = createSlice({
    name: 'master',
    initialState,
    reducers: {},
    extraReducers: {
        //get Company
        [getMaster.pending.type]: (state) => {
            state.loading = true;
        },
        [getMaster.fulfilled.type]: (state, action) => {
            const { company , jobGrade , termination , department , costCenter } = action.payload
            state.company = company;
            state.jobGrade = jobGrade;
            state.termination = termination;
            state.department = department;
            state.costCenter = costCenter;
            state.loading = false;
        },
        [getMaster.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        // Company Insert
        [insertCompany.pending.type]: (state) => {
            state.loading = true;
        },
        [insertCompany.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.NewUserResponseMessage = action.payload
            state.loading = false;
            state.error = null;
        },
        [insertCompany.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // Job Grade Insert
        [insertjobgrade.pending.type]: (state) => {
            state.loading = true;
        },
        [insertjobgrade.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.NewUserResponseMessage = action.payload
            state.loading = false;
            state.error = null;
        },
        [insertjobgrade.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // Termination Insert
        [insertTermination.pending.type]: (state) => {
            state.loading = true;
        },
        [insertTermination.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.NewUserResponseMessage = action.payload
            state.loading = false;
            state.error = null;
        },
        [insertTermination.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // Department Insert
        [insertDepartment.pending.type]: (state) => {
            state.loading = true;
        },
        [insertDepartment.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.NewUserResponseMessage = action.payload
            state.loading = false;
            state.error = null;
        },
        [insertDepartment.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // CostCenter Insert
        [inserCostCenter.pending.type]: (state) => {
            state.loading = true;
        },
        [inserCostCenter.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.NewUserResponseMessage = action.payload
            state.loading = false;
            state.error = null;
        },
        [inserCostCenter.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
    }
})
export default masterSlice